import constants from './constants';

const initialState = {
  loading: false,
  requests: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constants.actions.REQUEST_LOADING: {
      return {
        ...state,
        loading: true,
        requests: state.requests.concat([action.requestId]),
      };
    }
    case constants.actions.REQUEST_LOADED: {
      const index = state.requests.indexOf(action.requestId);
      if (index < 0) {
        return state;
      }
      const requests = state.requests.slice();
      requests.splice(index, 1);
      return {
        ...state,
        loading: requests.length > 0,
        requests,
      };
    }
    default:
      return state;
  }
}
